(async () => {
  const cartResponse = await fetch('/cart.js')
  const cart = await cartResponse.json()

  cart.items.forEach(cartItem => {
    const reorderLink = cartItem.properties._reorderLink
    if(reorderLink !== undefined) return
    const configId = cartItem.properties.configId || cartItem.properties._configId
    const productUrl = cartItem.properties.productUrl || cartItem.properties._productUrl
    if(configId === undefined || productUrl === undefined) return
    
    updateCartItem(cartItem.key, {
      ...cartItem.properties,
      _reorderLink: productUrl + '?configid=' + configId
    })
  })

  function updateCartItem(key, properties) {
    fetch('/cart/change.js',
    {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: key,
        properties
      })
    })
  }
})()